import Applayout from 'layouts/applayout';
var indexRoutes = [
    { path: '/', name: 'Dashboard', component: Applayout },
];

export default indexRoutes;
